<div *ngIf="mode === 'card'" class="container relative p-3 h-full min-h-full">
  <div class="mb-6 text-sm font-bold">{{ title }}</div>

  <div class="absolute bottom-0 mb-2">
    <div class="text-2xl font-semibold" *ngIf="!loading">{{ value }}</div>
    <div *ngIf="loading" class="flex gap-1 my-1">
      <p *ngFor="let item of [1, 2, 3]" width="15px" height="1.9rem"></p>
    </div>
    <p-progressSpinner
      styleClass="w-2rem h-2rem"
      strokeWidth="8"
      *ngIf="loading"
    ></p-progressSpinner>

    <small>{{ subtitle }}</small>
  </div>

  <div
    class="absolute bottom-0 right-0 p-2 pl-4 pt-4 {{ iconBg }}"
    style="border-radius: 50% 0 10px 50%"
  >
    <i [class]="icon" style="font-size: 1.2rem"></i>
  </div>
</div>

<!-- Line Layout -->
<div
  *ngIf="mode === 'line'"
  class="flex flex-column xl:flex-row align-items-center pr-4 pl-3 py-2 gap-3 border-top-1 surface-border"
>
  <i class="{{ icon }} text-md {{ iconBg }}"></i>
  <div
    class="flex flex-column sm:flex-row justify-content-between align-items-center flex-1 gap-4"
  >
    <div
      class="flex flex-column align-items-center sm:align-items-start no-gutter"
    >
      <div class="text-sm font-bold text-900">{{ title }}</div>
      <small *ngIf="subtitle">{{ subtitle }}</small>
    </div>
    <div
      class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2"
    >
      <p-progressSpinner
        styleClass="w-2rem h-2rem"
        strokeWidth="8"
        *ngIf="loading"
      ></p-progressSpinner>
      <span *ngIf="!loading" class="text-2xl font-semibold">{{ value }}</span>
    </div>
  </div>
</div>

<!-- Projection for custom content, e.g. Tooltip, etc. -->
<ng-content></ng-content>
